const JoinToSpeakIDSearchParamName = 'joinToSpeakID'
const JoinToSpeakPresenterTokenSearchParamName = 'joinToSpeakPresenterToken'
const JoinToSpeakQuestionSearchParamName = 'joinToSpeakQuestion'
const JoinToSpeakIsJoiningToSpeakSessionStorageKey = 'isJoiningToSpeak'
const JoinToSpeakHasJoinedToSpeakSessionStorageKey = 'hasJoinedToSpeak'

export {
  JoinToSpeakIDSearchParamName,
  JoinToSpeakPresenterTokenSearchParamName,
  JoinToSpeakQuestionSearchParamName,
  JoinToSpeakIsJoiningToSpeakSessionStorageKey,
  JoinToSpeakHasJoinedToSpeakSessionStorageKey,
}
